import { makeStyles } from '@material-ui/core';
import styled from 'styled-components';


export const useOrderCreationStyle = makeStyles(() => ({
  form: {
    alignItems    : 'center',
    display       : 'flex',
    justifyContent: 'center',
    flexDirection : 'column',
    marginTop     : '70px',
  },
}));

export const ModalIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 20px 15px;
`;


export const ModalTitleContainer = styled.div`
  margin-bottom: 25px;
  text-align: center;
`;

export const ModalTitle = styled.h3`
  font-weight: 400;
`;

export const ModalButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;

  & > button {
    width: 100%;
    max-width: 150px;
  }
`;
